import React from "react"
import { CardStyle, Link, Paragraph } from "buoy-core"
import { colors, responsive, fontWeight } from "buoy-theme"
import styled, { css } from "styled-components"
import privacyCardConfig from "./PrivacyCardConfig"

const PrivacyCardContainer = styled.div`
  ${CardStyle};
  border-top: none;
  display: flex;
  flex-wrap: wrap;
  ${responsive(
    "padding",
    "32px 24px",
    "32px 24px",
    "24px 24px 32px",
    "24px 24px 32px",
    "24px 16px 32px"
  )}
`

const PrivacyText = styled(Paragraph)`
  line-height: 1.25;
  margin-bottom: 0;
`

const PrivacyTitle = styled(Paragraph)`
  margin: 0 auto 16px 8px;
  line-height: 1.25;
  font-weight: ${fontWeight.regular};
`

const LockSection = styled.div`

  ${props => props.shackle ? css`
    height: 6px;
    width: 6px;
    margin: 0 auto;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border: 1px solid ${colors.neutralLight};
    border-bottom: none;
  ` : css`
    height: 10px;
    width: 12px;
    border-radius: 2px;

    background-color: ${colors.neutralLight};
  `};
`

const LockContainer = styled.div`
  display: inline-flex;
  width: 12px;
  flex-direction: column;
`

const PrivacyLock = () => (
  <LockContainer>
    <LockSection shackle />
    <LockSection />
  </LockContainer>
)

const generatePrivacyText = () => {
  return privacyCardConfig.sections.map(s => {
    const isDemo = window.location.pathname.startsWith("/demo")
    if (s.type === "text") {
      return s.text
    } else if (s.type === "link") {
      return <Link key={s.text} target="_blank" href={isDemo ? null : s.path}>{s.text}</Link>
    } else {
      return null
    }
  })
}

const PrivacyCard = () => (
  <PrivacyCardContainer>
    <PrivacyLock />
    <PrivacyTitle>{privacyCardConfig.title}</PrivacyTitle>
    <PrivacyText>
      {generatePrivacyText()}
    </PrivacyText>
  </PrivacyCardContainer>
)

export { PrivacyCard as default}


// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/PrivacyCard.js